export const withLoading = async (setLoading, awaitable) => {
    setLoading(true);
    const result = await awaitable();
    setLoading(false);
    return result;
}
